module.exports = __webpack_public_path__ + "img/thumbnail_AldabraGiantTortoise_j_normal.1e6c5c7f.png";